import React from 'react';
import { Box, NavSidebar } from 'edenred-ui';
import { useDispatch } from 'react-redux';

import { setGoToPageLink } from '@epi-actions/beneficiary';
import { useMenuDimensions, useOnboardingWizard } from '@epi-shared/hooks';
import { SidebarProps } from '@epi-models/core/Sidebar';

export const Sidebar = ({
  isOpen,
  toggleMenu,
  menuItems,
  isOrderInProgress
}: SidebarProps) => {
  const { isMobile } = useMenuDimensions();
  const { isOnBoardingActive } = useOnboardingWizard();
  const dispatch = useDispatch();

  const onboardingEnabledItemsIds = [
    'navbar-home',
    'navbar-help',
    'navbar-company-info',
    'navbar-voucher-order-history'
  ];

  return (
    <Box>
      <NavSidebar
        showToggle={!isMobile}
        temporary={isMobile}
        open={isOpen}
        onToggle={toggleMenu}
      >
        {menuItems.map(menuItem => {
          const disabled =
            (isOnBoardingActive &&
              !onboardingEnabledItemsIds.includes(menuItem.id)) ||
            isOrderInProgress;
          return (
            <NavSidebar.Item
              key={menuItem.name}
              name={menuItem.name}
              link={menuItem.link}
              icon={menuItem.icon}
              id={menuItem.id}
              exact={menuItem.exact}
              disabled={disabled}
              onClick={() =>
                isOrderInProgress && dispatch(setGoToPageLink(menuItem.link))
              }
            />
          );
        })}
      </NavSidebar>
    </Box>
  );
};
